export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
    seriesError: 'Trebuie selectată cel puțin o opțiune',
  },
  calculator: {
    title: 'Calculați economiile în Walutomat',
    forBuy: 'pentru',
    unsupportedPair: 'În prezent nu oferim rate pentru perechea valutară selectată.',
    spinnerError: {
      generic: 'A existat o problemă cu descărcarea datelor',
      toManyRequests:
        'Calculatorul nu este disponibil în acest moment. Încearcă din nou mai târziu sau contactează <a href="https://www.walutomat.com/ro/contact/">Serviciul de asistență pentru clienți</a>.',
    },
    commissionWT: 'Comision Walutomat',
    ctaButton: 'Schimbă',
    amountText: 'Suma',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Verificați cursurile și{{nbsp}}schimbați moneda în{{nbsp}}Walutomat – rapid și{{nbsp}}avantajos.',
    actualRate: 'Curs actual',
    buySelect: 'Cumpăr',
    sellSelect: 'Vând',
    exchangeAmountSellLabel: 'Veți primi',
    exchangeAmountBuyLabel: 'Depozit',
    commission: 'Comision promoțional ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Câmpul nu poate fi gol',
    requiredField: 'Câmpul este obligatoriu',
    requireAllFields: 'Toate câmpurile trebuie completate',
    passwordToShort: 'Parola trebuie să aibă 8 caractere',
    emailNotValid: 'Câmpul trebuie să conțină o adresă de e-mail validă',
    emailReserved: 'Adresa de e-mail este deja ocupată',
    emailUnregistered: 'Nu am găsit adresa ta de e-mail în baza noastră de date a clienților.',
    markField: 'Отметьте хотя бы один из флажков',
    serverUnknownError: 'Eroare de comunicare cu serverul',
    invalidCharacters: 'Câmpul conține caractere invalide',
    phoneNotValid: 'Numărul de telefon este incorect',
    checkBoxBelow: 'Please tick the box below to send a message',
    promocodeInvalid: 'Cod promoțional nevalid',
    newsletterAlreadySubscribed: 'Acest e-mail este deja abonat la newsletter.',
  },
  password: {
    show: 'arată',
    hide: 'ascunde',
  },
  howItWorks: {
    showButton: 'Arată mai mult',
    hideButton: 'Arată mai puțin',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Căutați o țară sau regiune...',
    searchAriaLabel: 'Căutați o țară sau regiune',
    searchMinChars: 'Introduceți <b>cel puțin 3 caractere</b> pentru a afișa rezultatele.',
    searchNoResults: '<b>Niciun rezultat.</b> Țara căutată nu a fost găsită.',
    searchError: '<b>A apărut o eroare.</b> Lista de oferte nu a putut fi încărcată.',
  },
}
